@if (displayType() !== 'panel') {
  <mat-form-field
    class="w-full"
    [class.mb-5]="displayType() !== 'filter' && (!required() || !hasError())"
    [class.select-classic]="displayType() === 'select'"
    [class.stroked-select-single]="displayType() === 'filter'"
    [ngClass]="cssClass()"
    appearance="outline"
  >
    @if (displayType() === 'filter') {
      <mat-select-trigger>
        {{ type() === eSpaceType.floor ? 'Floor' : 'Room' }}
      </mat-select-trigger>
    }
    <mat-select
      (openedChange)="onPanelChange($event)"
      (valueChange)="valueChanged($event)"
      [disabled]="isDisabled()"
      [placeholder]="type() === eSpaceType.floor ? 'Select floor' : 'Select room'"
      [value]="value()"
      panelClass="single-select-overlay"
    >
      @if (displayType() === 'filter') {
        <mat-option value="">All</mat-option>
      }
      @for (space of spaces(); track space.id) {
        <mat-option [value]="space.id">
          {{ space.friendlyName }}
        </mat-option>
      }
    </mat-select>
    <mat-icon
      class="arrow-down"
      fontIcon="keyboard_arrow_down"
      matSuffix
    />
  </mat-form-field>
} @else {
  <mat-expansion-panel [disabled]="isDisabled()">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <div class="mobile-single-select-title">
          {{ type() === eSpaceType.floor ? 'Floor' : 'Room' }}
          @if (selectedSpace()) {
            : {{ selectedSpace()!.friendlyName }}
          }
        </div>
        @if (selectedSpace()) {
          <button
            class="mobile-filter-clear-btn"
            (click)="changed.emit(null)"
          >
            Clear
          </button>
        }
      </mat-panel-title>
    </mat-expansion-panel-header>
    <ul class="mobile-single-filter-select">
      @for (space of spaces(); track space.id) {
        <li
          (click)="changed.emit(space.id)"
          [class.checked]="space.id === selectedSpace()?.id"
        >
          <span>{{ space.friendlyName }}</span>
          <i class="icon-check text-ui-green-light text-3xl"></i>
        </li>
      }
    </ul>
  </mat-expansion-panel>
}
